import type { StoreContextSettings } from './storeContextSettings';

import { DeliveryMode } from '../../structureDefinitions/storeState';

export const getStoreContextFromState = (state: {
    deliveryMode?: DeliveryMode;
    productionUnitId: string;
    storeName?: string | null;
    pickupPointId?: string | null;
    selectedStore?: string | null;
    zipCode?: string | null;
}): StoreContextSettings => {
    if (state.deliveryMode === DeliveryMode.homedelivery && state.productionUnitId) {
        return {
            deliveryMode: state.deliveryMode,
            storeName: state.storeName || undefined,
            pickupPointId: undefined,
            productionUnitId: state.productionUnitId,
            zipCode: state.zipCode || undefined,
        };
    }
    if (
        state.deliveryMode === DeliveryMode.pickup &&
        state.pickupPointId &&
        state.productionUnitId
    ) {
        return {
            deliveryMode: state.deliveryMode,
            pickupPointId: state.pickupPointId,
            productionUnitId: state.productionUnitId,
            storeName: state.storeName || undefined,
        };
    }

    return {
        deliveryMode: undefined,
        pickupPointId: undefined,
        productionUnitId: state.productionUnitId,
        storeName: undefined,
    };
};
